export const GET_RELATIONSHIPS = 'person/GET_RELATIONSHIPS'
export const SET_RELATIONSHIPS = 'person/SET_RELATIONSHIPS'
